var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgWhy3(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "why3_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .054h80v80H0v-80z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#why3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.14 64.507H5.86a4.688 4.688 0 01-4.688-4.688V5.913a4.688 4.688 0 014.687-4.687h68.282a4.688 4.688 0 014.687 4.687V59.82a4.688 4.688 0 01-4.687 4.688z",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.828 64.507a9.627 9.627 0 00.82 7.467l2.566 4.582a1.563 1.563 0 01-1.364 2.326h-21.7a1.562 1.562 0 01-1.364-2.326l2.565-4.582a9.627 9.627 0 00.82-7.467M17.446 56.382H1.172M78.828 56.382H22.915M61 30.054c0 11.598-9.402 21-21 21s-21-9.402-21-21 9.402-21 21-21 21 9.402 21 21z",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.589 38.156l.318-.09c.772-.221 1.375-.582 1.783-1.098.41-.518.607-1.168.607-1.93 0-.656-.143-1.223-.441-1.686l-.138-.193c-.365-.482-.962-.923-1.766-1.332l-.363-.184v6.513zm-2.246-16.114c-.69.193-1.256.489-1.685.898l-.175.183c-.432.493-.642 1.11-.642 1.831 0 .733.187 1.364.576 1.875l.007.009c.398.476 1.027.935 1.868 1.383l.368.195v-6.463l-.317.089zm.317 8.667h-.214l-.022-.01c-1.806-.76-3.083-1.575-3.858-2.435h0c-.763-.867-1.15-1.964-1.15-3.31 0-1.356.446-2.468 1.334-3.356.91-.912 2.135-1.477 3.692-1.682l.218-.028v-2.584h1.929v2.538l.23.018c1.408.109 2.738.436 3.992.979v1.976c-1.323-.58-2.642-.91-3.959-.983l-.263-.015v7.44l.153.065c1.071.45 1.938.888 2.606 1.315l.274.182.002.002c.706.478 1.227 1.05 1.574 1.718l.004.007c.36.642.548 1.468.548 2.492 0 1.442-.415 2.583-1.227 3.447-.814.847-2.043 1.406-3.72 1.65l-.214.031v2.638H39.66V40.28l-.246-.005a15.34 15.34 0 01-2.96-.338l-.004-.002c-.874-.174-1.605-.407-2.2-.689v-2.06c1.59.73 3.31 1.112 5.155 1.148l.255.005v-7.63z",
    fill: "#504FE9",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
export default SvgWhy3;